import { TLocation } from "~/types/location";
import { baseService } from "../base";
import { PaginationParams, PaginationResponse } from "../type";
import { CreateLocationParams, CreateStaffRoleParams } from "./common.types";
import axios from "axios";
import { TStaffRole } from "~/types";

export const commonServices = {
  getLocations: async (params?: PaginationParams) => {
    const { data } = await baseService.get<PaginationResponse<TLocation>>(
      "/locations",
      { params }
    );
    return data;
  },
  createLocation: async (location: CreateLocationParams) => {
    const { data } = await baseService.post("/locations", location);
    return data;
  },
  getCountries: async () => {
    const { data } = await axios.get<
      { name: { common: string }; cca2: string; flag: string }[]
    >("https://restcountries.com/v3.1/all?fields=name,flag,cca2");
    return data;
  },
  getStaffRoles: async () => {
    const { data } = await baseService.get<PaginationResponse<TStaffRole>>(
      "/staff-roles"
    );
    return data;
  },
  createStaffRole: async (role: CreateStaffRoleParams) => {
    const { data } = await baseService.post<TStaffRole>("/staff-roles", role);
    return data;
  },
  updateStaffRole: async ({
    id,
    ...role
  }: {
    id: string;
  } & Partial<CreateStaffRoleParams>) => {
    const { data } = await baseService.patch<TStaffRole>(
      `/staff-roles/${id}`,
      role
    );
    return data;
  },
  deleteStaffRole: async (id: string) => {
    await baseService.delete(`/staff-roles/${id}`);
  },
  getStaffRoleByName: async (name: string, clientId?: string) => {
    const { data } = await baseService.get<TStaffRole>(
      `/staff-roles/by-name/${encodeURIComponent(name)}`,
      { params: clientId ? { clientId } : {} }
    );
    return data;
  },
  getFileMimetype: async (fileUrl?: string) => {
    const response = await axios.head(fileUrl ?? "");
    const contentType = response.headers["content-type"];
    return contentType;
  },
};
